import React from 'react';

const DetallePagoSuscripcionRealizado = () => {
  return (
    <div className="col-12 text-center">
      <h1 className="font-mex text-mex">¡Felicidades!</h1>
      <h4 className="font-mex font-weight-light">Tu tarjeta ha sido registrada exitosamente</h4>
    </div>
  );
};

export default DetallePagoSuscripcionRealizado;
